<div class="-mb-[2px] mr-[0.075rem] flex flex-row items-center text-xs text-neutral-100">
  <button
    #trigger="cdkOverlayOrigin"
    (click)="isOpen = !isOpen"
    aria-label="Select language"
    cdkOverlayOrigin
    class="flex flex-row items-center"
    id="lang-select-button"
    type="button">
    <span class="mb-0.25 mr-1 text-sm">{{ selectedLanguage.abbreviation }}</span>
    <pay-icon [shape]="IconNames.ChevronDown" [size]="'xs'" />
  </button>
</div>

<ng-template
  payLibOutsideClick
  cdkConnectedOverlay
  (outsideClick)="isOpen = false"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  [ignoreClicksOnOverlayLayer]="true"
  id="lang-selector">
  <ol class="mt-2 flex w-auto min-w-[210px] flex-col rounded-lg border border-neutral-5 bg-neutral-0 text-sm shadow-select drop-shadow">
    @for (language of languages; track language) {
      <li
        class="last:border-0; cursor-pointer border-b border-neutral-5 hover:bg-neutral-5"
        tabindex="0"
        role="menuitem"
        [id]="'lang-' + language.abbreviation"
        (click)="selectLanguage(language)">
        <div class="flex flex-row items-center px-7 py-3">
          @if (language === selectedLanguage) {
            <pay-icon [shape]="IconNames.CheckmarkFilled" [size]="'xs'" class="mr-2 w-6 text-primary-100" />
          }
          <div class="flex-grow">{{ language.displayName }}</div>
          <div class="ml-2 text-neutral-60">{{ language.abbreviation }}</div>
        </div>
      </li>
    }
  </ol>
</ng-template>
